<template>
  <div class="shareContent">
    <div class="row">
      <div class="column left imageWrapper">
        <img :src="baseUrl" alt="Your district changes shape over time" />
      </div>
      <div class="column right">
        <div class="row nowrap">
          <div class="buttonWrapper half">
            <a data-size="large" target="_blank" :href="tweetLink" class="button twitter" title="Share this on Twitter"><span class="icon"></span> Tweet</a>
          </div>
          <div class="buttonWrapper half">
            <a :href="facebookLink" target="_blank" class="button facebook" title="Share this on Facebook"><span class="icon"></span> Share</a>
          </div>
        </div>
        <div class="row">
          <div class="buttonWrapper full">
            <button class="button copy" @click.prevent="copyUrl" title="Copy link to clipboard"><span class="icon">URL</span> {{ shareUrl }}</button>
            <input type="text" name="shareUrl" id="shareUrl" class="hidden" :value="shareUrl" />
          </div>
        </div>
        <hr class="subtleLine" />
        <div class="shareText">
          <p>
            One thing is for sure — no matter the shape of your district, and no matter how much (or how little) it’s changed over time — the maps drawn this year will play a vital role in our communities and affect our day to day lives for the next decade. The stakes could not be higher.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ShareContent',
  props: ['isMobile', 'districtIds', 'showOutro', 'firstYear'],
  data () {
    return {
      baseUrl: '/static/images/DTM.png',
      shareUrl: '',
      hashtags: '', // comma separated list
      twitterHandle: 'ACLU', // currently unused
    }
  },
  computed: {
    url () { // currently unused
      if (!this.districtIds || !this.districtIds.length) return null;

      return this.baseUrl + '?ids=' + this.districtIds.join('-');
    },
    message () {
      if (!this.districtIds || !this.districtIds.length) return null;
      if(this.districtIds.length == 1 ){
        return `The way our districts are drawn matters—for better or worse. My district hasn't changed since ${this.firstYear}. Now look up yours: `;
      } else {
        return `The way our districts are drawn matters—for better or worse. My district has changed at least ${this.districtIds.length} times since ${this.firstYear}. Now look up yours: `;
      }

    },
    tweetLink () {
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(this.message)}&url=${encodeURIComponent(this.shareUrl)}&hashtags=${encodeURIComponent(this.hashtags)}`;
    },
    facebookLink () {
      // This is the more "correct" way to share a link:
      // return `https://www.facebook.com/dialog/share?app_id=${this.facebookAppId}&display=popup&href=${encodeURIComponent(this.shareUrl)}&redirect_uri=${encodeURIComponent(this.shareUrl)}`;

      // The old way still works:
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareUrl)}`;
    }
  },
  watch: {
    districtIds() {
      // Keep shareUrl up to date
      this.shareUrl = document.location.href;
    }
  },
  methods: {
    copyUrl () {
      document.getElementById('shareUrl').select();
      document.execCommand('copy');
    },
    pledge () {
      this.showOutro('signup');
    }
  },
  created: function () {
    this.shareUrl = document.location.href
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

.left {
  width: 67%;
}
.right {
  width: 33%;
  padding: 3vh 3vw 1vh;
}
.imageWrapper {
  background-color: $darkBackgroundColor;
  background-image: url('../assets/images/loading.gif');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 80px;
  align-items: center;
  display: flex;
}
img {
  max-width: 85%;
  min-height: 100px;
  max-height: 70vh;
  margin: 3vh auto;
  border: 1px solid white;
}


a {
  font-weight: $bold;
}

.row {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;

  $buttonMargin: 0.8em;
  .buttonWrapper {
    width: 100%;
    margin-bottom: $buttonMargin;

    &:nth-child(2) {
      margin-left: $buttonMargin;
    }
  }

  .button {
    display: block;
    box-sizing: border-box;
    width: 100%;
    padding: 11px;
    border-radius: 3px;
    border-width: 0;
    text-align: center;
    // vertical-align: text-top;
    color: white;
    font-weight: bold;
    font-size: 1.125rem;
    text-decoration: none;
    cursor: pointer;
    transition: background-color $fastTransitionDuration;

    // Don't wrap text
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .icon {
      vertical-align: text-bottom;
    }

    &.twitter {
      background: #2FA4F0;
      .icon {
        background-image: url('../assets/icons/icon-twitter-ffffff.svg');
      }
      &:hover {
        background: lighten(#2FA4F0, 5%)
      }
    }
    &.facebook {
      background: #3E5C98;
      .icon {
        background-image: url('../assets/icons/icon-facebook-ffffff.svg');
      }
      &:hover {
        background: lighten(#3E5C98, 5%)
      }
    }
    &.copy {
      background: #999999;
      font-weight: normal;
      .icon {
        width: unset;
        font-weight: $bold;
        font-size: 0.83rem;
      }
      &:hover {
        background: lighten(#999999, 5%)
      }
    }
  }
}

.subtleLine {
  margin: 1vw 0;
  border: $border;
  border-width: 0.5px;
}
.hidden {
  position: absolute;
  left: -99999px;
}

.mq-mobile {
  .row {
    flex-wrap: wrap;
    &.nowrap {
      flex-wrap: nowrap;
    }
  }
  .left, .right {
    width: 100%;
    box-sizing: border-box;
    padding: 0.5em 1em 0;
  }
  .subtleLine {
    margin: 0.8em 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareContent.vue